import React from "react";
import c from "../etc/Const";
import NPlanitem from "./planitems/n_planitem";

import Window from "../gui/window";
import Emptyitem from "./planitems/emptyitem";

import {connect, useDispatch} from "react-redux";
import {useDrop} from "react-dnd";
import {selectItem} from "../../data/actions";

const Module = ({root, data, items, singleview}) => {
    const dispatch = useDispatch()

    const [{canDrop, isOver}, drop] = useDrop(() => ({
        accept: 'xxx',
        drop: () => ({
            name: `${data.id}`,
            type: "module",
        }),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop()
        })
    }))

    let planitems_r = items.filter((itm) => {
        return (itm.x !== undefined && itm.y !== undefined && itm.deleted !== true)
    });

    let xy = []
    let planitems = []
    planitems_r.map((itm) => {
        xy[itm.x + "_" + itm.y] = "there";
        if (itm.type === "sw" || itm.type === "sg" || itm.name === "sg" || itm.type === "tk" || itm.type === 'bk' || itm.type === 'fb' || itm.type === 'tt' || itm.type === 'tt_pos') {
            planitems.push(<NPlanitem key={itm.id} data={itm}/>)
        }
        if (itm.type === 'tt') { // or others?
            for (let k = 0; k < 10; k++) {
                for (let m = 0; m < 10; m++) {
                    xy[(parseInt(itm.x) + k) + "_" + (parseInt(itm.y) + m)] = "there";
                }
            }
        }
    });

    const w = data ? data.w : 0
    const h = data ? data.h : 0
    const prettyname = data ? data.prettyname : ""
    const id = data ? data.id : ""

    for (let k = 0; k < w; k++) {
        for (let m = 0; m < h; m++) {
            if (xy[(k) + "_" + (m)] !== "there") {
                planitems.push(<Emptyitem key={k + "_" + m} item={{x: k, y: m}} mod={data.id}/>)
            }
        }
    }

    function onContext(e) {
        e.preventDefault()
        dispatch(selectItem(data))
    }

    let _width = w ? (w * c.p1) : 800

    let moduleStyle = {
        width: _width + 'px',
        height: h ? (h * c.p1) : 100 + 'px',
        color: "#000000",
        top: singleview ? 5 : c.p2,
        left: singleview ? 5 : 0,
        position: 'absolute',
        background: 'rgb(143,161,152)',  //'rgb(143,161,152)',
        userSelect: "none",
        border: (isOver && canDrop) ? '2px solid green' : null,
    }

    return (
        <div ref={drop}>
            {singleview ?
                <div style={moduleStyle}>
                    {planitems}
                </div>
                : <Window headline={prettyname || id} id={id} type={'module'} width={_width}
                          edit={root.editmode} onContext={onContext}>
                    <div style={moduleStyle}>
                        {planitems}
                    </div>
                </Window>}
        </div>
    )
}

function mapStateToProps(state, other) {

    const ret = state.plan.items.filter(
        it => it.typename === "item" && it.module === other.modulid
    )

    const item = state.plan.items.find(
        it => it.id === other.modulid
    )

    return {root: state.root, data: item, items: ret}
}

export default connect(mapStateToProps)(Module)
